// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AboutRouteImport } from './routes/about'
import { Route as BodyRouteImport } from './routes/body'
import { Route as ClippingRouteImport } from './routes/clipping'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as CvRouteImport } from './routes/cv'
import { Route as LegalNoticeRouteImport } from './routes/legal-notice'
import { Route as LinksRouteImport } from './routes/links'
import { Route as MainProjectsRouteImport } from './routes/main-projects'
import { Route as PerformanceRouteImport } from './routes/performance'
import { Route as PhotoRouteImport } from './routes/photo'
import { Route as ScienceRouteImport } from './routes/science'
import { Route as SolidRouteImport } from './routes/solid'
import { Route as SoundRouteImport } from './routes/sound'
import { Route as SoundWorksRouteImport } from './routes/sound-works'
import { Route as SurfaceRouteImport } from './routes/surface'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as ThinkRouteImport } from './routes/think'
import { Route as VisualSensoryTherapyRouteImport } from './routes/visual-sensory-therapy'
import { Route as WorksRouteImport } from './routes/works'
import { Route as WriteRouteImport } from './routes/write'
import { Route as GuestSessionIndexRouteImport } from './routes/guest-session.index'
import { Route as GuestSessionLoginRouteImport } from './routes/guest-session.login'
import { Route as LabAfetoRouteImport } from './routes/lab.afeto'
import { Route as LabCargaRouteImport } from './routes/lab.carga'
import { Route as LabCuidadoRouteImport } from './routes/lab.cuidado'
import { Route as LabEcologiasRouteImport } from './routes/lab.ecologias'
import { Route as LabEstereogramaRouteImport } from './routes/lab.estereograma'
import { Route as LabMandalaRouteImport } from './routes/lab.mandala'
import { Route as LabNebulosasRouteImport } from './routes/lab.nebulosas'
import { Route as LabObservatorioRouteImport } from './routes/lab.observatorio'
import { Route as ThemesSlugRouteImport } from './routes/themes.$slug'
import { Route as WorkSlugRouteImport } from './routes/work.$slug'
import { Route as GuestSessionFilmIdRouteImport } from './routes/guest-session.film.$id'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const BodyRoute = BodyRouteImport.update({
            id: '/body',path: '/body',getParentRoute: () => rootRouteImport
          })
const ClippingRoute = ClippingRouteImport.update({
            id: '/clipping',path: '/clipping',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const CvRoute = CvRouteImport.update({
            id: '/cv',path: '/cv',getParentRoute: () => rootRouteImport
          })
const LegalNoticeRoute = LegalNoticeRouteImport.update({
            id: '/legal-notice',path: '/legal-notice',getParentRoute: () => rootRouteImport
          })
const LinksRoute = LinksRouteImport.update({
            id: '/links',path: '/links',getParentRoute: () => rootRouteImport
          })
const MainProjectsRoute = MainProjectsRouteImport.update({
            id: '/main-projects',path: '/main-projects',getParentRoute: () => rootRouteImport
          })
const PerformanceRoute = PerformanceRouteImport.update({
            id: '/performance',path: '/performance',getParentRoute: () => rootRouteImport
          })
const PhotoRoute = PhotoRouteImport.update({
            id: '/photo',path: '/photo',getParentRoute: () => rootRouteImport
          })
const ScienceRoute = ScienceRouteImport.update({
            id: '/science',path: '/science',getParentRoute: () => rootRouteImport
          })
const SolidRoute = SolidRouteImport.update({
            id: '/solid',path: '/solid',getParentRoute: () => rootRouteImport
          })
const SoundRoute = SoundRouteImport.update({
            id: '/sound',path: '/sound',getParentRoute: () => rootRouteImport
          })
const SoundWorksRoute = SoundWorksRouteImport.update({
            id: '/sound-works',path: '/sound-works',getParentRoute: () => rootRouteImport
          })
const SurfaceRoute = SurfaceRouteImport.update({
            id: '/surface',path: '/surface',getParentRoute: () => rootRouteImport
          })
const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const ThinkRoute = ThinkRouteImport.update({
            id: '/think',path: '/think',getParentRoute: () => rootRouteImport
          })
const VisualSensoryTherapyRoute = VisualSensoryTherapyRouteImport.update({
            id: '/visual-sensory-therapy',path: '/visual-sensory-therapy',getParentRoute: () => rootRouteImport
          })
const WorksRoute = WorksRouteImport.update({
            id: '/works',path: '/works',getParentRoute: () => rootRouteImport
          })
const WriteRoute = WriteRouteImport.update({
            id: '/write',path: '/write',getParentRoute: () => rootRouteImport
          })
const GuestSessionIndexRoute = GuestSessionIndexRouteImport.update({
            id: '/guest-session/',path: '/guest-session/',getParentRoute: () => rootRouteImport
          })
const GuestSessionLoginRoute = GuestSessionLoginRouteImport.update({
            id: '/guest-session/login',path: '/guest-session/login',getParentRoute: () => rootRouteImport
          })
const LabAfetoRoute = LabAfetoRouteImport.update({
            id: '/lab/afeto',path: '/lab/afeto',getParentRoute: () => rootRouteImport
          })
const LabCargaRoute = LabCargaRouteImport.update({
            id: '/lab/carga',path: '/lab/carga',getParentRoute: () => rootRouteImport
          })
const LabCuidadoRoute = LabCuidadoRouteImport.update({
            id: '/lab/cuidado',path: '/lab/cuidado',getParentRoute: () => rootRouteImport
          })
const LabEcologiasRoute = LabEcologiasRouteImport.update({
            id: '/lab/ecologias',path: '/lab/ecologias',getParentRoute: () => rootRouteImport
          })
const LabEstereogramaRoute = LabEstereogramaRouteImport.update({
            id: '/lab/estereograma',path: '/lab/estereograma',getParentRoute: () => rootRouteImport
          })
const LabMandalaRoute = LabMandalaRouteImport.update({
            id: '/lab/mandala',path: '/lab/mandala',getParentRoute: () => rootRouteImport
          })
const LabNebulosasRoute = LabNebulosasRouteImport.update({
            id: '/lab/nebulosas',path: '/lab/nebulosas',getParentRoute: () => rootRouteImport
          })
const LabObservatorioRoute = LabObservatorioRouteImport.update({
            id: '/lab/observatorio',path: '/lab/observatorio',getParentRoute: () => rootRouteImport
          })
const ThemesSlugRoute = ThemesSlugRouteImport.update({
            id: '/themes/$slug',path: '/themes/$slug',getParentRoute: () => rootRouteImport
          })
const WorkSlugRoute = WorkSlugRouteImport.update({
            id: '/work/$slug',path: '/work/$slug',getParentRoute: () => rootRouteImport
          })
const GuestSessionFilmIdRoute = GuestSessionFilmIdRouteImport.update({
            id: '/guest-session/film/$id',path: '/guest-session/film/$id',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,AboutRoute: AboutRoute,BodyRoute: BodyRoute,ClippingRoute: ClippingRoute,ContactRoute: ContactRoute,CvRoute: CvRoute,LegalNoticeRoute: LegalNoticeRoute,LinksRoute: LinksRoute,MainProjectsRoute: MainProjectsRoute,PerformanceRoute: PerformanceRoute,PhotoRoute: PhotoRoute,ScienceRoute: ScienceRoute,SolidRoute: SolidRoute,SoundRoute: SoundRoute,SoundWorksRoute: SoundWorksRoute,SurfaceRoute: SurfaceRoute,TermsRoute: TermsRoute,ThinkRoute: ThinkRoute,VisualSensoryTherapyRoute: VisualSensoryTherapyRoute,WorksRoute: WorksRoute,WriteRoute: WriteRoute,GuestSessionLoginRoute: GuestSessionLoginRoute,LabAfetoRoute: LabAfetoRoute,LabCargaRoute: LabCargaRoute,LabCuidadoRoute: LabCuidadoRoute,LabEcologiasRoute: LabEcologiasRoute,LabEstereogramaRoute: LabEstereogramaRoute,LabMandalaRoute: LabMandalaRoute,LabNebulosasRoute: LabNebulosasRoute,LabObservatorioRoute: LabObservatorioRoute,ThemesSlugRoute: ThemesSlugRoute,WorkSlugRoute: WorkSlugRoute,GuestSessionIndexRoute: GuestSessionIndexRoute,GuestSessionFilmIdRoute: GuestSessionFilmIdRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)